import React, { useState, useEffect } from "react";

const FormAction = ({
  onSubmit,
  onUpdate,
  onCancel,
  onApprove,
  onReject,
  onRecover,
  onClosePo,
  onApprovedPay,
  onSubmitTax,
  onUpdatePaid,
  onViewSo,
  docStatus,
  docPaidStatus,
  docIsRec,
  mode,
  setMode,
  disabled,
  disabledInv,
  disabledPay,
  creditCustomer,
  soNo,
  footer,
  showCancelButton = true,
  showApproveButton = false,
  showRejectButton = false,
  approveLabel = "อนุมัติ",
  rejectLabel = "ไม่อนุมัติ",
  approveDisabled = false,
  rejectDisabled = false,
  submitButtonLabel = "บันทึก",
  preSubmitAction = null,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [action, setAction] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  // Event listener สำหรับปุ่มที่ลูกค้าต้องการ
  useEffect(() => {
    const handleKeyDown = (event) => {
      // ถ้า modal เปิดอยู่ สำหรับปุ่ม Enter และ ESC
      if (showModal) {
        if (event.key === 'Enter') {
          event.preventDefault();
          if (!isButtonDisabled) {
            handleConfirm();
          }
        } else if (event.key === 'Escape') {
          event.preventDefault();
          if (!isButtonDisabled) {
            setShowModal(false);
          }
        }
        return;
      }

      // Modal ไม่เปิด
      if (event.key === 'F10') {
        event.preventDefault();

        if (isButtonDisabled || disabled) return;

        // สร้างใหม่: ไม่ต้องยืนยัน ให้บันทึกเลย (mode === "I" หรือ mode === "FA", "FT", "WDP")
        if (mode === "I" || mode === "FA" || mode === "FT" || mode === "WDP") {
          if (typeof onSubmit === "function") {
            onSubmit();
          }
        } else if (mode === "U") {
          if (!disabled) {
            handleShowModal("update");
          }
        }
      } else if (event.key === 'Escape') {
        event.preventDefault();

        if (isButtonDisabled) return;

        if (typeof setMode === "function") {
          setMode("S");
        } else {
          window.location.reload();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [mode, isButtonDisabled, disabled, setMode, showModal]);

  const handleShowModal = (action) => {
    // ถ้าเป็นการชำระเงิน ให้ข้าม Confirm Modal ไปเลย
    if (action === "approved") {
      setIsButtonDisabled(true);

      onApprovedPay();

      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 5000);
    } else if (action === "approve") {
      if (typeof onApprove !== "function") {
        return;
      }
      setAction(action);
      setShowModal(true);
    } else if (action === "reject") {
      if (typeof onReject !== "function") {
        return;
      }
      setAction(action);
      setShowModal(true);
    } else {
      setAction(action);
      setShowModal(true);
    }
  };

  const handleConfirm = () => {
    setShowModal(false);
    setIsButtonDisabled(true);

    if (action === "submit" && typeof onSubmit === "function") onSubmit();
    if (action === "update" && typeof onUpdate === "function") onUpdate();
    if (action === "recover" && typeof onRecover === "function") onRecover();
    if (action === "cancel" && typeof onCancel === "function") onCancel();
    if (action === "closePo" && typeof onClosePo === "function") onClosePo();
    if (action === "tax" && typeof onSubmitTax === "function") onSubmitTax();
    if (action === "updatePaid" && typeof onUpdatePaid === "function")
      onUpdatePaid();
    if (action === "approve" && typeof onApprove === "function") onApprove();
    if (action === "reject" && typeof onReject === "function") onReject();

    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 5000);
  };

  const getActionText = () => {
    switch (action) {
      case "submit":
        return "บันทึกข้อมูล";
      case "update":
        return "แก้ไขข้อมูล";
      case "recover":
        return window.location.pathname === "/bill-of-lading"
          ? "คืนสถานะใบเบิก"
          : window.location.pathname === "/bill"
            ? "ส่งกลับแก้ไขใบวางบิล"
            : "ยกเลิกปิดงาน PO";
      case "cancel":
        return "ยกเลิกข้อมูล";
      case "closePo":
        return "ปิดใบ PO";
      case "approved":
        return "ชำระเงิน";
      case "approve":
        return "อนุมัติเอกสาร";
      case "reject":
        return "ไม่อนุมัติเอกสาร";
      case "tax":
        return "ยืนยันการสร้างใบกํากับภาษี";
      case "updatePaid":
        return "ชำระเงินแล้ว ";
      default:
        return "";
    }
  };

  return (
    <>
      <div style={{ marginBottom: footer ? "72px" : "10px" }} />
      <div
        style={{
          position: footer ? "fixed" : "relative",
          bottom: footer ? 0 : "auto",
          left: footer ? 0 : "auto",
          right: footer ? 0 : "auto",
          backgroundColor: footer ? "#f8f9fa" : "transparent",
          zIndex: footer ? 500 : "auto",
          padding: "10px 0",
          boxShadow: footer ? "0 -2px 5px rgba(0, 0, 0, 0.06)" : "none",
        }}
      >
        <div className="row mt-2">
          {footer ? (
            <>
              <div className="col-2" />
              <div className="col-4">
                <button
                  onClick={() => handleShowModal("cancel")}
                  type="button"
                  hidden={
                    mode !== "U" || !showCancelButton
                  }
                  className="btn btn-lg shadow text-white"
                  style={{
                    marginLeft: "-70px",
                    backgroundColor: "#808080",
                    fontSize: "16px",
                  }}
                  disabled={disabled || docIsRec}
                >
                  {isButtonDisabled ? (
                    <>
                      <i
                        className="fa fa-spinner fa-spin me-2"
                        style={{ fontSize: "20px", color: "#ffffff" }}
                        aria-hidden="true"
                      ></i>
                      โปรดรอ
                    </>
                  ) : (
                    `ยกเลิก${{
                      "/deposit-document": "ใบมัดจำ",
                      "/purchase-order": "ใบสั่งซื้อ",
                      "/product-receipt": "ใบรับสินค้า",
                      "/payment-voucher": "ใบสำคัญจ่าย",
                      "/bill-of-lading": "ใบเบิก",
                      "/icebox": "ใบยืมสินค้า",
                      "/technical-equip-form": "ใบเบิกอุปกรณ์ช่าง",
                      "/office-equip-form": "ใบเบิกวัสดุใช้ภายใน",
                      "/quotation": "ใบเสนอราคา",
                      "/order-product": "ใบออเดอร์สินค้า",
                      "/billofsale": "ใบขาย",
                      "/picking-list": "Picking List",
                      "/bill": "ใบวางบิล",
                      "/invoice": "ใบกำกับภาษี",
                      "/tax": "หนังสือหัก ณ ที่จ่าย",
                    }[window.location.pathname] || ""
                    }`
                  )}
                </button>
                {window.location.pathname === "/bill" && (
                  <button
                    onClick={() => handleShowModal("recover")}
                    type="button"
                    hidden={mode === "I" || docStatus === 1}
                    className="btn btn-lg w-30] shadow text-white"
                    style={{
                      marginLeft: "20px",
                      backgroundColor: "blue",
                      fontSize: "16px",
                    }}
                  >
                    ส่งกลับแก้ไข
                  </button>
                )}
              </div>

              <div className="col-6 text-end" style={{ marginLeft: "-15px" }}>
                <button
                  onClick={() => {
                    if (typeof setMode === "function") {
                      setMode("S");
                    } else {
                      window.location.reload();
                    }
                  }}
                  type="button"
                  className="btn btn-lg w-25 shadow text-white"
                  style={{
                    marginLeft: "20px",
                    backgroundColor: "black",
                    fontSize: "16px",
                  }}
                  disabled={isButtonDisabled}
                >
                  กลับหน้าค้นหา
                </button>
                {preSubmitAction}
                <button
                  onClick={() => {
                    if (disabled) return;
                    // สร้างใหม่: ไม่ต้องยืนยัน ให้บันทึกเลย (mode === "I" หรือ mode === "FA", "FT", "WDP")
                    if ((mode === "I" || mode === "FA" || mode === "FT" || mode === "WDP") && typeof onSubmit === "function") {
                      onSubmit();
                    } else {
                      // แก้ไข: แสดง modal ยืนยัน
                      handleShowModal("submit");
                    }
                  }}
                  type="button"
                  hidden={mode === "U"}
                  className="btn btn-lg w-25 shadow text-white"
                  style={{
                    marginLeft: "20px",
                    backgroundColor: "#E13F57",
                    fontSize: "16px",
                  }}
                  disabled={isButtonDisabled || disabled}
                >
                  {isButtonDisabled ? (
                    <>
                      <i
                        className="fa fa-spinner fa-spin me-2"
                        style={{ fontSize: "20px", color: "#ffffff" }}
                        aria-hidden="true"
                      ></i>
                      โปรดรอ
                    </>
                  ) : (
                    submitButtonLabel
                  )}
                </button>
                {showApproveButton && (
                  <button
                    onClick={() => handleShowModal("approve")}
                    type="button"
                    className="btn btn-lg w-25 shadow text-white"
                    style={{
                      marginLeft: "20px",
                      backgroundColor: "#16a34a",
                      fontSize: "16px",
                    }}
                    hidden={isButtonDisabled || approveDisabled}
                  >
                    {isButtonDisabled ? (
                      <>
                        <i
                          className="fa fa-spinner fa-spin me-2"
                          style={{ fontSize: "20px", color: "#ffffff" }}
                          aria-hidden="true"
                        ></i>
                        โปรดรอ
                      </>
                    ) : (
                      approveLabel
                    )}
                  </button>
                )}
                {showRejectButton && (
                  <button
                    onClick={() => handleShowModal("reject")}
                    type="button"
                    className="btn btn-lg w-25 shadow text-white"
                    style={{
                      marginLeft: "20px",
                      backgroundColor: "#dc2626",
                      fontSize: "16px",
                    }}
                    hidden={isButtonDisabled || rejectDisabled}
                  >
                    {isButtonDisabled ? (
                      <>
                        <i
                          className="fa fa-spinner fa-spin me-2"
                          style={{ fontSize: "20px", color: "#ffffff" }}
                          aria-hidden="true"
                        ></i>
                        โปรดรอ
                      </>
                    ) : (
                      rejectLabel
                    )}
                  </button>
                )}
                <button
                  onClick={() => handleShowModal("approved")}
                  type="button"
                  hidden={
                    mode === "I" ||
                    docStatus !== 2 ||
                    window.location.pathname !== "/deposit-document"
                  }
                  className="btn btn-lg w-30 shadow text-white"
                  style={{
                    marginLeft: "20px",
                    backgroundColor: "green",
                    fontSize: "16px",
                  }}
                  disabled={docStatus !== 2}
                >
                  {isButtonDisabled ? (
                    <>
                      <i
                        className="fa fa-spinner fa-spin me-2"
                        style={{ fontSize: "20px", color: "#ffffff" }}
                        aria-hidden="true"
                      ></i>
                      โปรดรอ
                    </>
                  ) : (
                    "ยืนยันการชำระเงิน"
                  )}
                </button>
                <button
                  onClick={() => handleShowModal("update")}
                  type="button"
                  hidden={
                    mode === "I" ||
                    mode === "FA" ||
                    mode === "FT" ||
                    mode === "BL" ||
                    mode === "WDP" ||
                    docStatus === 4 ||
                    (window.location.pathname === "/quotation" &&
                      soNo &&
                      docStatus !== null)
                  }
                  className="btn btn-lg w-25 shadow text-white"
                  style={{
                    marginLeft: "20px",
                    backgroundColor: "#E13F57",
                    fontSize: "16px",
                  }}
                  disabled={
                    isButtonDisabled ||
                    disabled ||
                    (window.location.pathname === "/quotation" &&
                      soNo &&
                      docStatus !== null)
                  }
                >
                  {isButtonDisabled ? (
                    <>
                      <i
                        className="fa fa-spinner fa-spin me-2"
                        style={{ fontSize: "20px", color: "#ffffff" }}
                        aria-hidden="true"
                      ></i>
                      โปรดรอ
                    </>
                  ) : (
                    "แก้ไข"
                  )}
                </button>
              </div>
            </>
          ) : (
            <div
              className="col text-center"
              style={{ display: "flex", justifyContent: "right" }}
            >
              <button
                onClick={() => {
                  // สร้างใหม่: ไม่ต้องยืนยัน ให้บันทึกเลย (mode === "I" หรือ mode === "FA", "FT", "WDP")
                  if ((mode === "I" || mode === "FA" || mode === "FT" || mode === "WDP") && typeof onSubmit === "function") {
                    onSubmit();
                  } else {
                    // แก้ไข: แสดง modal ยืนยัน
                    handleShowModal(mode === "I" || mode === "FA" || mode === "FT" || mode === "WDP" ? "submit" : "update");
                  }
                }}
                type="button"
                className="btn btn-lg shadow text-white"
                style={{
                  width: "12%",
                  marginLeft: "20px",
                  backgroundColor: "#E13F57",
                  fontSize: "16px",
                }}
                disabled={isButtonDisabled}
              >
                {isButtonDisabled ? (
                  <>
                    <i
                      className="fa fa-spinner fa-spin me-2"
                      style={{ fontSize: "20px", color: "#ffffff" }}
                      aria-hidden="true"
                    ></i>
                    โปรดรอ
                  </>
                ) : mode === "I" ? (
                  "บันทึก"
                ) : (
                  "แก้ไข"
                )}
              </button>
            </div>
          )}
        </div>
      </div>
      {/* Modal */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        tabIndex="-1"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold">
                ยืนยันการ{getActionText()}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowModal(false)}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>คุณแน่ใจว่าต้องการดำเนินการ{getActionText()}หรือไม่?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-lg w-25 shadow text-white d-flex align-items-center justify-content-center"
                style={{
                  backgroundColor: "#E13F57",
                  fontSize: "16px",
                  position: "relative",
                  whiteSpace: "nowrap",
                }}
                onClick={handleConfirm}
                disabled={isButtonDisabled}
              >
                {isButtonDisabled ? (
                  <>
                    <i
                      className="fa fa-spinner fa-spin me-2"
                      style={{ fontSize: "20px", color: "#ffffff" }}
                      aria-hidden="true"
                    ></i>
                    กำลังโหลด
                  </>
                ) : (
                  "ยืนยัน (Enter)"
                )}
              </button>
              <button
                type="button"
                className="btn btn-lg w-30 shadow text-white"
                style={{ backgroundColor: "red", fontSize: "16px" }}
                onClick={() => setShowModal(false)}
                disabled={isButtonDisabled}
              >
                ยกเลิก
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormAction;
